import store from "@/store/index";
import { Key, Cookie } from "@/utils/storage/cookie";
import { permission } from "@/api/common";

export default function (el, bind) {
  // 获取当前登录用户
  const user = JSON.parse(Cookie.get(Key.userinfo));
  // 获取用户当前所拥有的所有按钮权限
  const buttonList = store.state.buttonEnameSet;
  // 获取页面路径
  const parentId = store.state.pageId;
  const ename = bind.value;
  const cname = el.textContent;
  if (bind) {
    if (buttonList && parentId) {
      // some 遇到 return true 时会结束数组遍历
      const hasPermission = buttonList.some((button) => {
        return button === ename;
      });

      // 如果没有权限, 将元素移除
      if (!hasPermission) {
        el && el.remove(el);

        // 开发管理员自动添加按钮权限
        if (user.loginName === "devadmin" && ename) {
          // 封装请求数据
          const menuButton = {
            ename: ename,
            cname: cname,
            parentId: parentId,
            type: 2,
            isPublic: 1,
            isHide: 0,
          };
          permission(menuButton).then(async (res) => {
            if (res.status == 200) {
              await store.dispatch("getButtonEnameSet");
            }
          });
        }
      }
    }
  } else {
    throw new Error(
      "需要指定权限标识！比如 v-permisson=" / "user_query" / ",注意单引号。"
    );
  }
}
